import { ethers } from "ethers"

export const CONTRACT_ADDRESS = "0xD694Ff813a1B9a4AD78Fd3f2fd5f4300B322f6C4"
export const USDT_ADDRESS = "0x337610d27c682E347C9cD60BD4b3b107C9d34dDd"

export const VAULT_ABI = [
  "function name() view returns (string)",
  "function symbol() view returns (string)",
  "function decimals() view returns (uint8)",
  "function totalSupply() view returns (uint256)",
  "function balanceOf(address account) view returns (uint256)",
  "function transfer(address to, uint256 amount) returns (bool)",
  "function allowance(address owner, address spender) view returns (uint256)",
  "function approve(address spender, uint256 amount) returns (bool)",
  "function transferFrom(address from, address to, uint256 amount) returns (bool)",
  "function userVestings(address user) view returns (uint256 totalAllocation, uint256 claimedAmount)",
  "function isListingOpen() view returns (bool)",
  "function totalListingAllocated() view returns (uint256)",
  "function buyItem(uint256 _amount, address _referrer, uint256 _nonce, bytes _signature) external",
  "function buyToken(uint256 _amount, uint256 _ztdAmount, address _referrer, uint256 _nonce, bytes _signature) external",
  "function claimListing() external",
  "function getClaimableAmount(address _user) view returns (uint256)",
  "function withdrawReferral(uint256 _amount) external",
  "function isAdmin(address) view returns (bool)",
  "function adminCount() view returns (uint256)",
  "function mainPoolBalance() view returns (uint256)",
  "function referrals(address) view returns (uint256 availableToWithdraw, uint256 alreadyWithdrawn, uint256 totalEarned)",
  "function createWithdrawRequest(address _to, uint256 _amount, uint8 _type) external",
  "function approveRequest(uint256 _requestId) external",
  "function withdrawRequests(uint256) view returns (address to, uint256 amount, uint8 reqType, bool executed, uint256 approvalCount)",
  "function hasApproved(uint256, address) view returns (bool)",
  "function totalReferralsCount() view returns (uint256)",
  "function configureListing(uint256[] memory _times, uint256[] memory _percentages) external",
  "function toggleListing(bool _status) external",
  "function totalReferralAvailable() view returns (uint256)",
  "function getAllReferralsData() view returns (tuple(address refAddress, uint256 available, uint256 withdrawn, uint256 total)[])",
  "function totalVested() view returns (uint256)",
  "function tournamentPoolBalance() view returns (uint256)",
  "function depositTournamentViaMetaMask(uint256 _tournamentId, uint256 _amount) external",
  "function depositTournamentViaInternalBalance(uint256 _tournamentId, uint256 _amount) external",
  "function getAllTournamentDeposits() view returns (tuple(address player, uint256 tournamentId, uint256 amount)[])",
]

export const ERC20_ABI = [
  "function approve(address spender, uint256 amount) returns (bool)",
  "function allowance(address owner, address spender) view returns (uint256)",
  "function balanceOf(address account) view returns (uint256)",
  "function decimals() view returns (uint8)",
  "function symbol() view returns (string)",
]

async function getProvider() {
  if (typeof window === "undefined" || !window.ethereum) {
    throw new Error("MetaMask is not installed")
  }

  const provider = new ethers.providers.Web3Provider(window.ethereum)
  await provider.send("eth_requestAccounts", [])
  return provider
}

export async function getSigner() {
  const provider = await getProvider()
  return provider.getSigner()
}

export async function getNetwork() {
  const provider = await getProvider()
  return provider.getNetwork()
}

export async function getVaultContract() {
  const signer = await getSigner()
  return new ethers.Contract(CONTRACT_ADDRESS, VAULT_ABI, signer)
}

export async function getUsdtContract() {
  const signer = await getSigner()
  return new ethers.Contract(USDT_ADDRESS, ERC20_ABI, signer)
}

export async function getDecimals() {
  const usdtContract = await getUsdtContract()
  return await usdtContract.decimals()
}

export async function getZtdDecimals() {
  const contract = await getVaultContract()
  try {
    return await contract.decimals()
  } catch (error) {
    return 18
  }
}

export async function getZtd(address) {
  try {
    const contract = await getVaultContract()
    const ztdDecimals = await getZtdDecimals()
    const balance = await contract.balanceOf(address)
    return parseFloat(ethers.utils.formatUnits(balance, ztdDecimals))
  } catch (error) {
    console.error("Error getting ZTD: ", error)
  }
  return 0
}

export async function getLockedZtd(address) {
  try {
    const contract = await getVaultContract()
    const ztdDecimals = await getZtdDecimals()

    const vesting = await contract.userVestings(address)
    const total = ethers.utils.formatUnits(vesting.totalAllocation, ztdDecimals)
    const claimed = ethers.utils.formatUnits(vesting.claimedAmount, ztdDecimals)
    return parseFloat(total) - parseFloat(claimed)
  } catch (error) {
    console.error("Error getting Locked ZTD: ", error)
  }
  return 0
}

export async function checkApprove(amountWei, userAddress) {
  const usdtContract = await getUsdtContract()
  const tx = await usdtContract.approve(CONTRACT_ADDRESS, amountWei)
  await tx.wait()
}
